import { parseJsonIfValid } from '@salescore/buff-common'
import type { ReactElement } from 'react'

import { CodeHighlighter } from '../CodeHighlighter'

export const JsonSyntaxHighlighter = ({ jsonString }: { jsonString: string }): ReactElement => {
  const parsedJson = parseJsonIfValid(jsonString)

  return (
    <CodeHighlighter language="json" customStyle={{ padding: 10 }} wrapLongLines={true}>
      {parsedJson === undefined ? jsonString : JSON.stringify(parsedJson, null, 2)}
    </CodeHighlighter>
  )
}
